import React from "react";
import ProdctSellForm from "../components/General/ProdctSellForm";
export default function SellProduct() {
  return (
    <div>
      <ProdctSellForm></ProdctSellForm>
    </div>
  );
}
